import { Pipe, PipeTransform, NgZone, ChangeDetectorRef, OnDestroy} from "@angular/core";
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'timeAgo',
    pure: false,
    standalone: false
})
export class TimeAgoPipe implements PipeTransform, OnDestroy {
	private timer: number;
	constructor(private changeDetectorRef: ChangeDetectorRef, private ngZone: NgZone, private translateService: TranslateService) {}

	transform(value:string) {
		this.removeTimer();
		let d = new Date(value);
		let now = new Date();
		let seconds = Math.round(Math.abs((now.getTime() - d.getTime())/1000));
		let timeToUpdate = (Number.isNaN(seconds)) ? 1000 : this.getSecondsUntilUpdate(seconds) *1000;
		this.timer = this.ngZone.runOutsideAngular(() => {
			if (typeof window !== 'undefined') {
				return window.setTimeout(() => {
					this.ngZone.run(() => this.changeDetectorRef.markForCheck());
				}, timeToUpdate);
			}
			return null;
		});
		let minutes = Math.round(Math.abs(seconds / 60));
		let hours = Math.round(Math.abs(minutes / 60));
		let days = Math.round(Math.abs(hours / 24));
		let months = Math.round(Math.abs(days/30.416));
		let years = Math.round(Math.abs(days/365));
		if (Number.isNaN(seconds)){
			return '';
		} else if (seconds <= 45) {
			return this.translateService.instant('time-ago.a-few-seconds');
		} else if (seconds <= 90) {
			return this.translateService.instant('time-ago.a-minute-ago');
		} else if (minutes <= 45) {
			return minutes + ` ${this.translateService.instant('time-ago.minutes-ago', {minutes: minutes})}`;
		} else if (minutes <= 90) {
			return this.translateService.instant('time-ago.an-hour-ago');
		} else if (hours <= 22) {
			return hours + ` ${this.translateService.instant('time-ago.hours-ago', {hours: hours})}`;
		} else if (hours <= 36) {
			return this.translateService.instant('time-ago.a-day-ago');
		} else if (days <= 25) {
			return this.translateService.instant('time-ago.days-ago', {days: days});
		} else if (days <= 45) {
			return this.translateService.instant('time-ago.a-month-ago');
		} else if (days <= 345) {
			return months + ` ${this.translateService.instant('time-ago.months-ago', {months: months})}`;
		} else if (days <= 545) {
			return this.translateService.instant('time-ago.a-year-ago');
		} else { // (days > 545)
			return years + ` ${this.translateService.instant('time-ago.years-ago', {years: years})}`;
		}
	}
	ngOnDestroy(): void {
		this.removeTimer();
	}
	private removeTimer() {
		if (this.timer) {
			window.clearTimeout(this.timer);
			this.timer = null;
		}
	}
	private getSecondsUntilUpdate(seconds:number) {
		let min = 60;
		let hr = min * 60;
		let day = hr * 24;
		if (seconds < min) { // less than 1 min, update every 2 secs
			return 2;
		} else if (seconds < hr) { // less than an hour, update every 30 secs
			return 30;
		} else if (seconds < day) { // less then a day, update every 5 mins
			return 300;
		} else { // update every hour
			return 3600;
		}
	}
}